var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAuth)?[_c('login')]:[_c('div',{staticClass:"wrapper"},[_c('sidebar'),_c('div',{staticClass:"main-panel"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('router-view'),_c('vue-progress-bar')],1)])])],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }